<ng-container *ngIf="diner">
  <ion-header>
    <ion-toolbar mode="md"
                 color="dark">
      <ion-title>{{ 'pos.mealPlan' | transloco }}</ion-title>
      <ion-buttons slot="end">
        <ion-button mode="md"
                    debounce-click
                    [debounceTime]="0"
                    (debounceClick)="onCloseModal()">{{ 'common.close' | transloco }}</ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>
  <ion-content>
    <div class="meal-plan-modal">
      <p [innerHTML]="'pos.useMealPlanQuestion' | transloco: {
        firstName: diner.first_name,
        lastName: diner.last_name,
        type: (isServiceAppointment ? ('services.service' | transloco) : ('common.meal' | transloco))
      }"></p>
      <ion-item *ngIf="diner.meal_plan as mealplan">
        <ion-label><strong>{{ mealplan.name}}</strong></ion-label>
        <ion-label slot="end">{{ 'payment.balance' | transloco }}: {{ mealplan | mealPlanBalance}}</ion-label>
      </ion-item>
    </div>
  </ion-content>
  <ion-footer>
    <ion-toolbar mode="md"
                 color="light">
      <ion-buttons slot="start">
        <ion-button mode="md"
                    color="light"
                    fill="solid"
                    debounce-click
                    [debounceTime]="0"
                    (debounceClick)="onPayForMeal()">{{ isServiceAppointment ? ('pos.payForService' | transloco) : ('pos.payForMeal' | transloco) }}</ion-button>
      </ion-buttons>
      <ion-buttons slot="end" *ngIf="diner.meal_plan as mealplan">
        <ion-button mode="md"
                    color="dark"
                    fill="solid"
                    debounce-click
                    [debounceTime]="0"
                    (debounceClick)="onUseMealPlan(mealplan.id)">{{ 'pos.useMealPlan' | transloco }}</ion-button>
      </ion-buttons>
    </ion-toolbar>
  </ion-footer>

</ng-container>
